import React from 'react';

export default ({ onSubmit }) => {
  let [submitted, setSubmitted] = React.useState(false);

  const fields = [];

  const getFormData = () => {
    return fields.reduce((formData, field) => {
      formData[field.name] = field.value;

      return formData;
    }, {});
  };

  const validateFields = () => {
    const fieldsToValidate = fields;
    const fieldsValid = fieldsToValidate.map(field => {
      return field.validate();
    });

    const formValid = fieldsValid.every(isValid => {
      return isValid === true;
    });

    return formValid;
  };

  return {
    handleSubmit: e => {
      e.preventDefault();
      const formValid = validateFields();
      setSubmitted(true);
      return onSubmit(getFormData(), formValid);
    },
    addField: field => fields.push(field),
    getFormData,
    submitted
  };
};
